import React from "react";
import { useI18n } from "bananas-commerce-admin";

import { Typography } from "@mui/material";
import { Stack } from "@mui/material";

import dayjs from "dayjs";

import { PublishingRuleCreateSchema } from "../../types";
import DateField from "../DateField";

export interface PeriodSectionProps {
  schedule: PublishingRuleCreateSchema;
  setSchedule: React.Dispatch<React.SetStateAction<PublishingRuleCreateSchema>>;
  error?: string;
}

const PeriodSection: React.FC<PeriodSectionProps> = ({
  schedule,
  setSchedule,
  error,
}) => {
  const { t } = useI18n();
  return (
    <Stack gap={1}>
      <Typography gutterBottom variant="subtitle1">
        {t("Period")}
      </Typography>
      <Stack direction="row" spacing={2}>
        <Stack>
          <Typography
            color="text.secondary"
            fontWeight={500}
            sx={{ mb: 1 }}
            variant="body2"
          >
            {t("Från")}
          </Typography>
          <DateField
            error={Boolean(error)}
            value={schedule.from_date ? dayjs(schedule.from_date) : null}
            onChange={(date) =>
              setSchedule((prev) => ({
                ...prev,
                from_date: date?.format("YYYY-MM-DD") ?? "",
              }))
            }
          />
        </Stack>
        <Typography color="text.secondary" pt={4.5} variant="body2">
          —
        </Typography>
        <Stack>
          <Typography
            color="text.secondary"
            fontWeight={500}
            sx={{ mb: 1 }}
            variant="body2"
          >
            {t("Till")}
          </Typography>
          <DateField
            error={Boolean(error)}
            value={schedule.to_date ? dayjs(schedule.to_date) : null}
            onChange={(date) =>
              setSchedule((prev) => ({
                ...prev,
                to_date: date?.format("YYYY-MM-DD") ?? "",
              }))
            }
          />
        </Stack>
      </Stack>
      {error && (
        <Typography color="error" variant="caption">
          {error}
        </Typography>
      )}
      <Typography color="text.secondary" variant="caption">
        {t(
          "Perioden kommer att skriva över tidigare inlagd period inom det datumspann som anges.",
        )}
      </Typography>
    </Stack>
  );
};

export default PeriodSection;
